import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import useBeacon from '../hooks/useBeacon';
import { useBridge } from '../hooks/useBridge';
import useNav from '../hooks/useNav';
import { personalInfo } from '../recoil';
import { beaconSelector } from '../recoil/selector';
import { PAGE_NM } from '../types/types';

export const useMtgLoading = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_LOADING,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const br: any = useBridge();
  const closeWebview = () => {
    br.close();
  };
  const [popup, setPopup] = useState({
    message: '조금만 기다리면 결과를 볼 수 있어요.\n알림으로 받아보시겠어요?',
    description: '결과가 나오면 알림으로 알려드려요.',
    open: false,
    cancelText: '아니오',
    onClickCancel: () => setPopup((prev) => ({ ...prev, open: false })),
    confirmText: '네',
    onClickConfirm: () => closeWebview(),
  });

  const [personal] = useRecoilState(personalInfo);
  // const [mInfo] = useRecoilState(mortgageInfo);
  const [title, setTitle] = useState<string>('');
  const titleContent = [
    '오버테이크가 금융사에서\n 대출 심사를 진행 중이에요',
    '대출 심사를 진행해도\n 신용점수에 영향을 주지 않아요',
    '조금만 기다려주세요\n 대출 심사가 거의 다 끝나가요',
    `${personal.custNm} 님에게 알맞은\n 대출 상품을 찾고 있어요`,
    '주택담보대출 Tip!\n 주택을 바꿔가며 조회해볼 수 있어요',
    '완료됐어요!',
  ];
  // saveInputInfo
  // const applyPreReq = useBaseParam(mutatePreReq, {
  //   preRequestSeq: mInfo.preRequestSeq
  // });
  // const saveInputInfo = async () => {
  //   const response = await applyPreReq();
  // };

  const { navigate } = useNav();

  useEffect(() => {
    const random = Math.floor(Math.random() * (5 - 1) + 1);
    setTitle(titleContent[random - 1]);
    // void saveInputInfo();
    setTimeout(() => {
      setTitle(titleContent[titleContent.length - 1]);
    }, 2000);
  }, []);

  useEffect(() => {
    if (title === titleContent[titleContent.length - 1]) {
      setTimeout(() => {
        navigate('/mtg/result', { replace: true });
      }, 1000);
    }
  }, [title]);

  return {
    titleContent: title,
    popup,
  };
};
